'use client';

import { useState } from 'react';
// import { AddToCartButton } from '../cart/AddToCartButton';
import IngredientsCollapsible from '../product/fragments/ingredients-collapsible';
import ProductAttributesSelector from '../product/fragments/attributes-selector';
import Image from 'next/image';
import type { ProductAggregateDocument, ProductVariantDocument } from '@/types/manage.types';
import { AddToCartButton } from '../cart/AddToCartButton';

type Props = {
  product: ProductAggregateDocument;
};

const ProductPage = ({ product }: Props) => {
  const [selectedVariant, setSelectedVariant] = useState<ProductVariantDocument | null>(null);

  return (
    <div className="bg-white max-w-7xl mx-auto overflow-hidden w-full flex flex-col md:flex-row min-h-screen md:mt-10">
      {/* Image */}
      <div className="overflow-hidden md:w-2/5 rounded-lg">
        <div className="aspect-square rounded-lg overflow-hidden bg-gradient-to-br from-orange-200 to-amber-200">
          <Image
            src={product.images[0]}
            alt={product.name}
            height={1080}
            width={1080}
            className="w-full h-full object-contain transition-transform duration-500"
          />
        </div>
      </div>

      <div className="p-6 pb-32 md:ps-10  md:w-3/5">
        <h2 className="text-xl md:text-4xl font-semibold text-gray-800 mb-2">{product.name}</h2>
        <p className="text-gray-600 mb-4 md:text-2xl">{product.description}</p>

        {/* Ingredients Toggle */}
        <div className="mb-4 p-2">
          <IngredientsCollapsible product={product} />
        </div>

        {/* Attribute Selection (Grouped by Key) */}
        <ProductAttributesSelector product={product} onVariantChange={(selected) => setSelectedVariant(selected)} />

        {/* Price Display - Action: add to cart */}
        {selectedVariant ? (
          <div className="flex justify-between flext-wrap items-center mt-8 md:text-2xl">
            <p className="font-semibold text-gray-500 italic">${selectedVariant.price}</p>
            {/* <AddToCartButton product={product} selectedVariant={selectedVariant} /> */}
            <AddToCartButton product={product} selectedVariant={selectedVariant} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProductPage;
